<template>
  <content-panel>
    <table-panel ref="tablePanel">
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column show-overflow-tooltip label="消息名称" prop="messageTitle"></el-table-column>
        <el-table-column show-overflow-tooltip label="触发条件" prop="triggerConditions"></el-table-column>
        <el-table-column show-overflow-tooltip label="通知对象" prop="notificationObject"></el-table-column>
        <el-table-column show-overflow-tooltip label="通知频率" prop="notificationFrequency"></el-table-column>
        <el-table-column show-overflow-tooltip label="未处理再次通知" prop="notificationAgain"></el-table-column>
        <el-table-column show-overflow-tooltip label="消息通知内容" prop="messageContent" width="260"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态" prop="status" width="80">
          <template slot-scope="scope">
            <span :style="`color:${scope.row.status == '启用'? '#FF7400' : ''}`">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="更新人" prop="lastUpdatedBy" width="100"></el-table-column>
        <el-table-column show-overflow-tooltip label="更新时间" prop="lastUpdateDate" width="160"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <edit-dialog :visible.sync="isShowEdit" :rowData="rowData" v-if="isShowEdit" @success="onSearch" />
  </content-panel>
</template>

<script>
import editDialog from "./components/edit.vue";
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "Notify",
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      isShowEdit: false,
      rowData: {},
      searchFormData: [],
      rules: {},
      reportName: "yoLinkMessageConfig",
      loading: false,
      searchForm: {},
      searchCollapse: false,
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    edit(row) {
      this.rowData = row
      this.isShowEdit = true
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch()
  },
};
</script>

<style lang="stylus" scoped></style>
